import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import * as Yup from "yup";
import React from "react";
import { SelectChangeEvent } from "@mui/material/Select";
import { getStorageData } from "framework/src/Utilities";
import { configJSON } from "./CustomisableUserProfilesController";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import moment from "moment";
// Customizable Area End
export interface Props {
  // Customizable Area Start
  open: boolean;
  onClose: () => void;
  onSave: (newHighlight: any) => void;
  careerData: any | null;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  isEditing: boolean;
  careerHighlightData: {};
  projectName: string;
  role: string;
  startMonth: string;
  startYear: string;
  endMonth: string;
  endYear: string;
  ongoing: boolean;
  location: string;
  projectLink: string;
  description: string;
  image: File | null;
  imagePreview: string | null;
  id: number;
  selectedStartMonth: string[];
  selectedStartYear: string[];
  selectedEndMonth: string[];
  selectedEndYear: string[];
  errors: {
    projectName: string;
    role: string;
    startMonth: string;
    startYear: string;
    endMonth: string;
    endYear: string;
    location: string;
    projectLink: string;
    description: string;
    image: string;
  };
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class EditCareerHightlightsController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  userAddCareerHighlightApiCallId: string = "";
  editCareerHighlightsApiCallId: string = "";
  // Customizable Area End
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      isEditing: false,
      careerHighlightData: {},
      projectName: "",
      role: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      ongoing: false,
      location: "",
      projectLink: "",
      description: "",
      image: null,
      id: 0,
      imagePreview: null,
      selectedStartMonth: [],
      selectedStartYear: [],
      selectedEndMonth: [],
      selectedEndYear: [],
      errors: {
        projectName: "",
        role: "",
        startMonth: "",
        startYear: "",
        endMonth: "",
        endYear: "",
        location: "",
        projectLink: "",
        description: "",
        image: "",
      },
      // Customizable Area End
    };
    // Customizable Area Start
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    if (this.props.careerData) {
      this.setState({
        id: this.props.careerData.id,
        projectName: this.props.careerData.attributes?.project_name,
        role: this.props.careerData.attributes?.role,
        startMonth: this.props.careerData.attributes?.start_date,
        startYear: this.props.careerData.attributes?.start_year,
        endMonth: this.props.careerData.attributes?.end_date,
        endYear: this.props.careerData.attributes?.end_year,
        location: this.props.careerData.attributes?.location,
        projectLink: this.props.careerData.attributes?.project_link,
        description: this.props.careerData.attributes?.description,
        image: this.props.careerData.attributes?.career_images_urls,
        ongoing: this.props.careerData.attributes?.ongoing,
      });
    }
    // Customizable Area End
  }
  async receive(from: string, message: Message) {
    // Customizable Area Start

    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (apiRequestCallId && responseJson) {
        if (apiRequestCallId === this.userAddCareerHighlightApiCallId) {
          this.props.onSave(responseJson.data);
          this.props.onClose();
        } else if (
          apiRequestCallId === this.editCareerHighlightsApiCallId &&
          responseJson
        ) {
          this.props.onSave(responseJson.data);
          this.props.onClose?.();
        }
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isOngoing = event.target.checked;

    this.setState(
      (prevState) => ({
        ongoing: isOngoing,
        endMonth: isOngoing ? "" : prevState.endMonth,
        endYear: isOngoing ? "" : prevState.endYear,
      }),
      this.validateForm
    );
  };

  handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ image: file, imagePreview: reader.result as string });
      };
      reader.readAsDataURL(file);
      this.validateFile(file);
    }
  };

  isValidUrl = (value: string): boolean => {
    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  };

  isImageFile = (file: File): boolean =>
    ["image/jpg", "image/jpeg", "image/png"].includes(file.type);

  validationSchema = Yup.object().shape({
    projectName: Yup.string()
      .trim()
      .required("Project name is required")
      .max(250, "Project name must be at most 250 characters!")
      .matches(
        /^(?!\s)(?!.*\s$)[\S ]+$/,
        "Project name cannot start or end with spaces"
      ),
    role: Yup.string()
      .trim()
      .required("Role is required")
      .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed!")
      .max(250, "Role must be at most 250 characters!"),
    startMonth: Yup.string().required("Start month is required"),
    startYear: Yup.string().required("Start year is required"),
    endMonth: Yup.string()
      .nullable()
      .when("ongoing", {
        is: false,
        then: (schema: Yup.StringSchema) =>
          schema.required("Institute End month is required"),
        otherwise: (schema: Yup.StringSchema) => schema.notRequired(),
      }),
    endYear: Yup.string()
      .nullable()
      .when("ongoing", {
        is: false,
        then: Yup.string().required("End year is required"),
        otherwise: Yup.string().notRequired(),
      })
      .test(
        "endDateCheck",
        "End date must be same or after start date and not in the future",
        function (endYear) {
          const { startYear, startMonth, endMonth, ongoing } = this.parent;

          if (ongoing) return true;
          if (!startYear || !startMonth || !endYear || !endMonth) return true;

          const startDate = moment(
            `${startYear}-${startMonth}-01`,
            "YYYY-MMMM-DD"
          );
          const endDate = moment(`${endYear}-${endMonth}-01`, "YYYY-MMMM-DD");
          const today = moment().startOf("day");

          return (
            endDate.isSameOrAfter(startDate) && endDate.isSameOrBefore(today)
          );
        }
      ),
    location: Yup.string()
      .trim()
      .required("Location is required")
      .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed!")
      .max(250, "Location must be at most 250 characters!"),
    projectLink: Yup.string()
      .trim()
      .url("Enter a valid URL")
      .required("Project link is required"),
    description: Yup.string()
      .max(1000, "Description cannot exceed 1000 characters")
      .required("Description is required"),
    image: Yup.mixed()
      .required("Image is required")
      .test(
        "fileSize",
        "File is too large. Max size is 10MB",
        (value: File | string | null | undefined) => {
          if (!value) return false;
          if (value instanceof File) {
            return value.size <= 10 * 1024 * 1024;
          }
          if (typeof value === "string") {
            return this.isValidUrl(value);
          }
          return false;
        }
      )
      .test(
        "fileType",
        "Only image files are allowed (jpg, png, jpeg)",
        (value: File | string | null | undefined) => {
          if (!value) return false;
          if (value instanceof File) {
            return this.isImageFile(value);
          }
          if (typeof value === "string") {
            return this.isValidUrl(value);
          }
          return false;
        }
      ),
  });

  validateFile = (file: File | null) => {
    if (file) {
      const { size, type } = file;
      let imageError = "";
      if (size > 10 * 1024 * 1024) {
        imageError = "File is too large. Max size is 10MB";
      }
      if (!["image/jpg", "image/jpeg", "image/png"].includes(type)) {
        imageError = "Only image files are allowed (jpg, png, jpeg)";
      }
      this.setState((prevState) => ({
        errors: { ...prevState.errors, image: imageError },
      }));
    }
  };

  validateForm = () => {
    const {
      projectName,
      role,
      location,
      startMonth,
      startYear,
      endMonth,
      endYear,
      ongoing,
      description,
      image,
      projectLink,
    } = this.state;
    return this.validationSchema
      .validate(
        {
          projectName,
          role,
          location,
          startMonth,
          startYear,
          description,
          endMonth,
          endYear,
          ongoing,
          image,
          projectLink,
        },
        { abortEarly: false }
      )
      .then(() => {
        this.setState({
          errors: {
            projectName: "",
            role: "",
            startMonth: "",
            startYear: "",
            endMonth: "",
            endYear: "",
            location: "",
            projectLink: "",
            description: "",
            image: "",
          },
        });
        return true;
      })
      .catch((err) => {
        const errors: any = {};
        err.inner.forEach((e: any) => {
          errors[e.path] = e.message;
        });
        this.setState({ errors });
        return false;
      });
  };

  handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | { name?: string; value: unknown }
    >
  ) => {
    const target = event.target as HTMLInputElement;
    const { name, value } = target;
    this.setState((prevState) => {
      return {
        ...prevState,
        [name]: value,
        errors: { ...prevState.errors, [name]: "" },
      };
    }, this.validateForm);
  };

  isSaveDisabled = () => {
    const {
      projectName,
      role,
      location,
      projectLink,
      description,
      startMonth,
      startYear,
      endMonth,
      endYear,
      image,
      ongoing,
    } = this.state;
    const isFieldsFilled =
      projectName &&
      role &&
      location &&
      projectLink &&
      description &&
      startMonth &&
      startYear &&
      image &&
      (ongoing || (endMonth && endYear));
    if (!isFieldsFilled) return true;
    if (!ongoing) {
      const startDate = new Date(`${startYear}-${startMonth}-01`);
      const endDate = new Date(`${endYear}-${endMonth}-01`);
      if (endDate <= startDate) return true;
    }
    return false;
  };

  calculateDuration = () => {
    const monthMap: { [key: string]: number } = {
      January: 1,
      February: 2,
      March: 3,
      April: 4,
      May: 5,
      June: 6,
      July: 7,
      August: 8,
      September: 9,
      October: 10,
      November: 11,
      December: 12,
    };
    const startMonthInt = monthMap[this.state.startMonth];
    const startYearInt = parseInt(this.state.startYear, 10);
    const startDate = new Date(startYearInt, startMonthInt - 1);
    const endDate = this.state.ongoing
      ? new Date()
      : new Date(
          parseInt(this.state.endYear, 10),
          monthMap[this.state.endMonth] - 1
        );
    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    if (months < 0) {
      years--;
      months += 12;
    }
    if (years === 0) return `${months} months`;
    if (months === 0) return `${years} years`;
    return `${years} years ${months} months`;
  };

  handleSave = async () => {
    const isValid = await this.validateForm();
    if (isValid) {
      const { endMonth, endYear, ongoing, id } = this.state;
      const finalEndMonth = ongoing ? "" : endMonth;
      const finalEndYear = ongoing ? "" : endYear;
      const finalOngoing = ongoing || (!endMonth && !endYear);
      const newHighlight = {
        id: this.state.id,
        img: this.state.image,
        projectName: this.state.projectName,
        role: this.state.role,
        startMonth: this.state.startMonth,
        startYear: this.state.startYear,
        endMonth: finalEndMonth,
        endYear: finalEndYear,
        duration: this.calculateDuration(),
        location: this.state.location,
        description: this.state.description,
        projectLink: this.state.projectLink,
        ongoing: finalOngoing,
      };
      if (id) {
        await this.EditCareerHighlight(id, newHighlight);
      } else {
        await this.userCareerHighlight(newHighlight);
      }
    }
  };

  handleStartMonthChange = (event: SelectChangeEvent<string>) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        startMonth: event.target.value,
        errors: { ...prevState.errors, startMonth: "" },
      };
    }, this.validateForm);
  };

  handleStartYearChange = (event: SelectChangeEvent<string>) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        startYear: event.target.value,
        errors: { ...prevState.errors, startYear: "" },
      };
    }, this.validateForm);
  };

  handleEndMonthChange = (event: SelectChangeEvent<string>) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        endMonth: event.target.value,
        errors: { ...prevState.errors, endMonth: "" },
      };
    }, this.validateForm);
  };

  handleEndYearChange = (event: SelectChangeEvent<string>) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        endYear: event.target.value,
        errors: { ...prevState.errors, endYear: "" },
      };
    }, this.validateForm);
  };

  CustomUncheckedIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="5.5" stroke="#94A3B8" />
    </svg>
  );

  CustomCheckedIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="6" fill="#652784" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.0611 5.42238C15.5183 5.73229 15.6376 6.35411 15.3277 6.81124L10.2432 14.3112C10.0771 14.5562 9.8111 14.715 9.51671 14.745C9.22232 14.7749 8.92977 14.673 8.71777 14.4665L4.80234 10.6536C4.40667 10.2683 4.39827 9.6352 4.78358 9.23953C5.16888 8.84386 5.80199 8.83546 6.19766 9.22077L9.25771 12.2007L13.6723 5.68895C13.9822 5.23182 14.604 5.11247 15.0611 5.42238Z"
        fill="white"
      />
    </svg>
  );

  buildCareerHighlightFormData(highlightData: any, includeId = false) {
    const formData = new FormData();
    if (includeId && highlightData.id) {
      formData.append("id", String(highlightData.id));
    }
    if (highlightData.img instanceof File || includeId) {
      formData.append("career_image", highlightData.img);
    }
    formData.append("project_name", highlightData.projectName);
    formData.append("role", highlightData.role);
    formData.append("start_date", highlightData.startMonth);
    formData.append("start_year", String(highlightData.startYear));
    formData.append("end_date", highlightData.endMonth);
    formData.append("end_year", String(highlightData.endYear));
    formData.append("duration", highlightData.duration);
    formData.append("location", highlightData.location);
    formData.append("description", highlightData.description);
    formData.append("project_link[]", highlightData.projectLink);
    formData.append("is_ongoing", String(highlightData.ongoing));
    return formData;
  }

  userCareerHighlight = async (highlightData: any) => {
    const token = await getStorageData(configJSON.TOKEN);
    const formData = this.buildCareerHighlightFormData(highlightData, true);
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.userAddCareerHighlightApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.addCareerHighlights
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({ token })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  EditCareerHighlight = async (id: number, highlightData: any) => {
    const token = await getStorageData(configJSON.TOKEN);
    const formData = this.buildCareerHighlightFormData(highlightData);
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.editCareerHighlightsApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.addCareerHighlights}/${id}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({ token })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPatchMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // Customizable Area End
}
